// import React from 'react';
import styled from 'styled-components';
import AutoComplete from 'material-ui/AutoComplete';

/*

Props:

• minWidth
• marginLeft
• marginRight

*/

const paddingLeft = 0;

export const AutoCompleteSC = styled(AutoComplete)`
    display: flex !important;
    flex: 1 !important;
    width: ${props => (props.width) ? props.width : '0'}px !important;

    div {
        padding-left: ${paddingLeft}px;
    }

    input {
        padding-left: ${paddingLeft}px !important;
    }

    div > hr {
        display: none;
    }
    
`;



// WEBPACK FOOTER //
// ./src/js/components/Search/AutoCompleteSC.jsx